import { useShallow } from "zustand/react/shallow";

import Modal from "ds/components/Modal";
import ModalContent from "ds/components/Modal/Content";
import Box from "ds/components/Box";

import useCommandPaletteStore from "./store/useCommandPaletteStore";
import CommandPaletteHeader from "./components/layout/Header";
import CommandPaletteFooter from "./components/layout/Footer";
import CommandPaletteContent from "./components/layout/Content";
import useCommandPaletteKeyboard from "./hooks/useKeyboard";
import styles from "./styles.module.css";

const CommandPalette = () => {
  const { isModalOpen, currentView, setModalOpen } = useCommandPaletteStore(
    useShallow((state) => ({
      isModalOpen: state.isModalOpen,
      currentView: state.currentView,
      setModalOpen: state.setModalOpen,
    }))
  );

  useCommandPaletteKeyboard();

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => setModalOpen(false)}
      isDismissable={currentView === "main"}
      size="large"
      className={styles.modal}
      ariaLabel="Command palette"
    >
      <ModalContent padding="0" className={styles.modalContent}>
        <CommandPaletteHeader />
        <Box direction="column" fullWidth fullHeight scrollable>
          <CommandPaletteContent />
        </Box>
        <CommandPaletteFooter />
      </ModalContent>
    </Modal>
  );
};

export default CommandPalette;
